import axios from "axios";
import { useMutation } from "react-query";

const logout = async (): Promise<string> => {
  const { data } = await axios.post("https://imirt.ca:4051/api/logout");
  console.log("promise logout data is");
  console.log(data);
  return data;
};

export function useLogout() {
  const { isLoading, mutateAsync } = useMutation(logout);
	console.log("i am logging out in the logout function in use ");
  return { isLoggingOut: isLoading, logout: mutateAsync };
}
